import type { MailListItemAnimation } from '../store/schema/MailListItemAnimationStore';

export function cancelAllRowAnimationsForAnimation(animation: MailListItemAnimation): void {
    const activeRowAnimations = animation.rowAnimations;
    if (activeRowAnimations) {
        for (const activeRowAnimation of activeRowAnimations) {
            if (activeRowAnimation) {
                // Clear callbacks to break closure references to DOM elements
                activeRowAnimation.onfinish = null;
                activeRowAnimation.oncancel = null;
                activeRowAnimation.cancel();
            }
        }
        // Clear the array to release Animation object references
        animation.rowAnimations = [];
    }
}
